function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { forwardRef, Link, useTheme } from '@chakra-ui/react';
import { fillClassname, fillStyles, itemClassname, pillsClassname } from "./constants";
import { jsx as _jsx } from "react/jsx-runtime";
export var NavLink = forwardRef((props, ref) => {
  var theme = useTheme();
  return /*#__PURE__*/_jsx(Link, _extends({
    color: "neutral.500",
    display: "block",
    px: 4,
    py: 2,
    tabIndex: 0,
    _hover: {
      color: 'primary.500'
    },
    _focus: {
      color: 'primary.500'
    }
  }, props, {
    ref: ref,
    textDecoration: "none",
    sx: {
      ["." + pillsClassname + " &"]: {
        borderRadius: 'full',
        boxShadow: '0px 2px 4px rgba(77, 38, 38, 0.15)',
        '.active': {
          boxShadow: 'inset 0px 0px 4px rgba(0, 0, 0, 0.25)',
          filter: 'grayscale(100%)'
        },
        ':not(.active):hover': {
          boxShadow: "0px 2px 4px " + theme.colors.primary[100]
        }
      },
      ["." + fillClassname + " > .&"]: fillStyles,
      ["." + fillClassname + " ." + itemClassname + " &"]: {
        w: '100%'
      }
    }
  }));
});
//# sourceMappingURL=NavLink.js.map